import type { SchemaInput } from './schema-input.js';
import { isString, isObject, isFunction } from './runtime-values.js';
/** Count JSON bytes without making a second copy of a complete document. */
export function jsonByteLength(value: SchemaInput, stopAfter = Infinity): number {
  let bytes = 0;
  const ancestors = new Set<object>();
  function string(text: string): void {
    bytes += 2;
    for (let i = 0; i < text.length && bytes <= stopAfter; i++) {
      const code = text.charCodeAt(i);
      if (code === 34 || code === 92 || code === 8 || code === 9 || code === 10 || code === 12 || code === 13) bytes += 2;
      else if (code < 32) bytes += 6;
      else if (code < 128) bytes++;
      else if (code < 2048) bytes += 2;
      else if (code >= 0xd800 && code <= 0xdbff && text.charCodeAt(i + 1) >= 0xdc00 && text.charCodeAt(i + 1) <= 0xdfff) { bytes += 4; i++; }
      else if (code >= 0xd800 && code <= 0xdfff) bytes += 6;
      else bytes += 3;
    }
  }
  function visit(item: SchemaInput): void {
    if (bytes > stopAfter) return;
    if (isString(item)) { string(item); return; }
    if (item === null || !isObject(item)) { bytes += (JSON.stringify(item) ?? 'null').length; return; }
    if (ancestors.has(item)) throw new TypeError('Circular JSON value');
    ancestors.add(item);
    bytes += 2;
    let first = true;
    if (Array.isArray(item)) {
      for (const child of item) {
        if (bytes > stopAfter) break;
        if (!first) bytes++;
        first = false;
        visit(child);
      }
    } else {
      for (const [key, child] of Object.entries(item)) {
        if (bytes > stopAfter) break;
        if (child === undefined || isFunction(child) || Object.prototype.toString.call(child) === '[object Symbol]') continue;
        if (!first) bytes++;
        first = false;
        string(key); bytes++; visit(child);
      }
    }
    ancestors.delete(item);
  }
  visit(value);
  return bytes;
}
